import { render } from "./VersioniSottoProgetto.vue?vue&type=template&id=5fc0b8f3&ts=true"
import script from "./VersioniSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./VersioniSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__